import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext, useSiteSelection } from "@context";
import { ROLES } from "@constants/roles";
import "./dash.css";

const DashBreadcrumb = () => {
    const { auth } = useContext(AuthContext);
    const { compName, siteName, clearSiteSelection } = useSiteSelection();
    const navigate = useNavigate();
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    const handleCompanyClick = () => {
        clearSiteSelection();
        navigate("/dash/company");
    };

    return (
        <div className="dash-breadcrumb">
            {isAdminOrR1 ? (
                <button
                    type="button"
                    className="dash-breadcrumb-comp-link"
                    onClick={handleCompanyClick}
                >
                    {compName}
                </button>
            ) : (
                <span className="dash-breadcrumb-comp">{compName}</span>
            )}
            <span className="dash-breadcrumb-sep">&gt;</span>
            <Link to="/dash/site" className="dash-breadcrumb-site">{siteName}</Link>
        </div>
    );
};

export default DashBreadcrumb;
